export default __webpack_public_path__ + "static/Youtube_SD_Card-85fce325d4d59549931c060aec75b25c.png";